var _rect, _rect2, _ellipse, _ellipse2, _rect3, _rect4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzayStartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 92,
    viewBox: "0 0 360 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_3995)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1339_3995)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 359.573,
    height: 91.5017,
    fill: "#6C5DD3"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 359.573,
    height: 91.5017,
    fill: "url(#paint0_linear_1339_3995)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: -0.000976562,
    y: 46.3604,
    width: 359.573,
    height: 45.1409,
    fill: "#6C5DD3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.786,
    cy: 83.5715,
    rx: 168.229,
    ry: 37.2107,
    transform: "rotate(-180 179.786 83.5715)",
    fill: "url(#paint1_radial_1339_3995)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.883,
    cy: 6.23881,
    rx: 167.407,
    ry: 14.5571,
    transform: "rotate(-180 179.883 6.23881)",
    fill: "url(#paint2_radial_1339_3995)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7959,
    width: 316.097,
    height: 2.07958,
    fill: "url(#paint3_linear_1339_3995)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7959,
    y: 89.4219,
    width: 316.097,
    height: 2.07958,
    fill: "url(#paint4_linear_1339_3995)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_1339_3995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.749 44.0871C137.296 44.4365 138.519 45.2101 139.417 46.4079C140.341 47.5808 140.802 48.9284 140.802 50.4507C140.802 52.6966 140.029 54.4559 138.482 55.7286C136.934 57.0013 134.763 57.6377 131.968 57.6377H118.904V31.2478H131.557C134.252 31.2478 136.36 31.8467 137.883 33.0445C139.43 34.2424 140.203 35.9268 140.203 38.0979C140.203 39.6451 139.792 40.9428 138.968 41.9909C138.17 43.0141 137.097 43.7128 135.749 44.0871ZM126.241 41.7289H129.947C131.794 41.7289 132.717 40.9677 132.717 39.4455C132.717 37.8733 131.794 37.0872 129.947 37.0872H126.241V41.7289ZM130.508 51.7234C132.355 51.7234 133.278 50.9498 133.278 49.4025C133.278 48.604 133.029 47.9926 132.53 47.5683C132.056 47.1441 131.369 46.932 130.471 46.932H126.241V51.7234H130.508ZM160.713 53.333H151.355L149.932 57.6377H142.221L151.841 31.2478H160.301L169.884 57.6377H162.135L160.713 53.333ZM158.878 47.7181L156.034 39.1835L153.226 47.7181H158.878ZM192.077 49.6271C192.077 51.7234 191.39 53.5201 190.018 55.0174C188.645 56.4898 186.736 57.4006 184.291 57.75V59.0976C185.514 59.0976 186.624 59.4594 187.622 60.1831C188.645 60.9068 189.157 62.0173 189.157 63.5146C189.157 65.0369 188.62 66.1598 187.547 66.8835C186.474 67.6072 185.202 67.9691 183.729 67.9691H177.628V64.1135H182.868C183.692 64.1135 184.104 63.8515 184.104 63.3274C184.104 62.8034 183.692 62.5414 182.868 62.5414H179.949V57.75C177.478 57.4256 175.482 56.5522 173.959 55.1297C172.437 53.7073 171.614 51.8107 171.489 49.44H179.312C179.387 50.3633 179.662 51.0371 180.136 51.4613C180.61 51.8856 181.221 52.0977 181.97 52.0977C182.644 52.0977 183.193 51.9355 183.617 51.6111C184.066 51.2617 184.291 50.7875 184.291 50.1886C184.291 49.415 183.929 48.8161 183.205 48.3919C182.482 47.9676 181.309 47.4935 179.687 46.9694C177.965 46.3955 176.567 45.8464 175.494 45.3224C174.446 44.7734 173.523 43.9873 172.724 42.9641C171.95 41.916 171.564 40.556 171.564 38.884C171.564 37.1871 171.988 35.7397 172.836 34.5418C173.685 33.319 174.858 32.3957 176.355 31.7718C177.852 31.1479 179.549 30.836 181.446 30.836C184.515 30.836 186.961 31.5597 188.783 33.0071C190.629 34.4295 191.615 36.4384 191.74 39.0337H183.767C183.742 38.2352 183.492 37.6362 183.018 37.237C182.569 36.8377 181.982 36.638 181.259 36.638C180.71 36.638 180.261 36.8003 179.911 37.1247C179.562 37.4491 179.387 37.9108 179.387 38.5097C179.387 39.0088 179.574 39.4455 179.949 39.8198C180.348 40.1692 180.834 40.4811 181.408 40.7556C181.982 41.0052 182.831 41.3296 183.954 41.7289C185.626 42.3028 186.998 42.8768 188.071 43.4508C189.169 43.9998 190.105 44.7859 190.879 45.809C191.677 46.8072 192.077 48.0799 192.077 49.6271ZM202.824 52.0228H211.022V57.6377H195.487V31.2478H202.824V52.0228ZM230.57 53.333H221.211L219.789 57.6377H212.078L221.698 31.2478H230.158L239.741 57.6377H231.992L230.57 53.333ZM228.735 47.7181L225.891 39.1835L223.083 47.7181H228.735Z",
    fill: "#FEE6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.749 44.0871C137.296 44.4365 138.519 45.2101 139.417 46.4079C140.341 47.5808 140.802 48.9284 140.802 50.4507C140.802 52.6966 140.029 54.4559 138.482 55.7286C136.934 57.0013 134.763 57.6377 131.968 57.6377H118.904V31.2478H131.557C134.252 31.2478 136.36 31.8467 137.883 33.0445C139.43 34.2424 140.203 35.9268 140.203 38.0979C140.203 39.6451 139.792 40.9428 138.968 41.9909C138.17 43.0141 137.097 43.7128 135.749 44.0871ZM126.241 41.7289H129.947C131.794 41.7289 132.717 40.9677 132.717 39.4455C132.717 37.8733 131.794 37.0872 129.947 37.0872H126.241V41.7289ZM130.508 51.7234C132.355 51.7234 133.278 50.9498 133.278 49.4025C133.278 48.604 133.029 47.9926 132.53 47.5683C132.056 47.1441 131.369 46.932 130.471 46.932H126.241V51.7234H130.508ZM160.713 53.333H151.355L149.932 57.6377H142.221L151.841 31.2478H160.301L169.884 57.6377H162.135L160.713 53.333ZM158.878 47.7181L156.034 39.1835L153.226 47.7181H158.878ZM192.077 49.6271C192.077 51.7234 191.39 53.5201 190.018 55.0174C188.645 56.4898 186.736 57.4006 184.291 57.75V59.0976C185.514 59.0976 186.624 59.4594 187.622 60.1831C188.645 60.9068 189.157 62.0173 189.157 63.5146C189.157 65.0369 188.62 66.1598 187.547 66.8835C186.474 67.6072 185.202 67.9691 183.729 67.9691H177.628V64.1135H182.868C183.692 64.1135 184.104 63.8515 184.104 63.3274C184.104 62.8034 183.692 62.5414 182.868 62.5414H179.949V57.75C177.478 57.4256 175.482 56.5522 173.959 55.1297C172.437 53.7073 171.614 51.8107 171.489 49.44H179.312C179.387 50.3633 179.662 51.0371 180.136 51.4613C180.61 51.8856 181.221 52.0977 181.97 52.0977C182.644 52.0977 183.193 51.9355 183.617 51.6111C184.066 51.2617 184.291 50.7875 184.291 50.1886C184.291 49.415 183.929 48.8161 183.205 48.3919C182.482 47.9676 181.309 47.4935 179.687 46.9694C177.965 46.3955 176.567 45.8464 175.494 45.3224C174.446 44.7734 173.523 43.9873 172.724 42.9641C171.95 41.916 171.564 40.556 171.564 38.884C171.564 37.1871 171.988 35.7397 172.836 34.5418C173.685 33.319 174.858 32.3957 176.355 31.7718C177.852 31.1479 179.549 30.836 181.446 30.836C184.515 30.836 186.961 31.5597 188.783 33.0071C190.629 34.4295 191.615 36.4384 191.74 39.0337H183.767C183.742 38.2352 183.492 37.6362 183.018 37.237C182.569 36.8377 181.982 36.638 181.259 36.638C180.71 36.638 180.261 36.8003 179.911 37.1247C179.562 37.4491 179.387 37.9108 179.387 38.5097C179.387 39.0088 179.574 39.4455 179.949 39.8198C180.348 40.1692 180.834 40.4811 181.408 40.7556C181.982 41.0052 182.831 41.3296 183.954 41.7289C185.626 42.3028 186.998 42.8768 188.071 43.4508C189.169 43.9998 190.105 44.7859 190.879 45.809C191.677 46.8072 192.077 48.0799 192.077 49.6271ZM202.824 52.0228H211.022V57.6377H195.487V31.2478H202.824V52.0228ZM230.57 53.333H221.211L219.789 57.6377H212.078L221.698 31.2478H230.158L239.741 57.6377H231.992L230.57 53.333ZM228.735 47.7181L225.891 39.1835L223.083 47.7181H228.735Z",
    fill: "url(#paint5_linear_1339_3995)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1339_3995",
    x: -20.7958,
    y: -18.7163,
    width: 401.164,
    height: 133.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.31834
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.19896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1339_3995",
    result: "effect2_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.15917
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.15917
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1339_3995",
    result: "effect3_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_1339_3995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_1339_3995",
    x: 114.745,
    y: 24.5972,
    width: 133.313,
    height: 49.6103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.07958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.03979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_dropShadow_1339_3995",
    result: "effect2_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.07958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect2_dropShadow_1339_3995",
    result: "effect3_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.11938
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1339_3995",
    result: "effect4_dropShadow_1339_3995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_1339_3995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_3995",
    x1: 179.786,
    y1: 0,
    x2: 179.786,
    y2: 91.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1339_3995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.786 83.5715) rotate(90) scale(37.2107 168.229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1339_3995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.883 6.23881) rotate(90) scale(14.5571 167.407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1339_3995",
    x1: 335.133,
    y1: 0,
    x2: 20.0013,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492063,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1339_3995",
    x1: 335.133,
    y1: 89.4219,
    x2: 20.0013,
    y2: 89.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492063,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1339_3995",
    x1: 178.422,
    y1: 16.6377,
    x2: 178.422,
    y2: 72.6377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_3995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359.573,
    height: 91.5017,
    rx: 20.7958,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzayStartIcon);
export default __webpack_public_path__ + "static/media/uzayStartIcon.7cb0d35f258667d25e2549f6172a13dd.svg";
export { ForwardRef as ReactComponent };